export default { sha: 'bbf7880f5f99aa8eddd41235c4bfd515c6bb35b6', buildNumber: 'undefined' }
